import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
  LearnersReportDto,
  ReportDetailsDto,
  ReportsChart,
  ReportsTableParams,
  UpdateReportsFilter,
} from "src/app/_models/Reports";
import { AppConstants } from "src/app/constants/constants";
import { HttpHeadersConstants } from "src/app/constants/HttpParamsConstants";
import { AggregateReportTypeList, ReportTypes } from "src/app/constants/ReportConstants";
import { APP_CONFIG } from "src/app/lib/angular/injection-tokens";
import { IAppConfig } from "src/app/lib/config/app-config";

@Injectable({
  providedIn: "root",
})
export class LearnerReportService {
  private baseUrl: string = this.config.protectedResourceEndpoint;
  private static readonly path: string = "Reports/";
  private static readonly GET_REPORT_NAMES: string = "GetReportNames";
  private static readonly GET_REPORT_DETAILS: string = "GetReportDetails";
  private static readonly UPDATE_REPORTS_BY_FILTER: string =
    "UpdateReportsFilter";
  private static readonly GET_REPORTS_FILTER: string = "GetReportsFilter";
  private static readonly GENERATE_REPORTS: string = "GenerateReport";
  private static readonly REPORTS_TABLE_RESULT: string = "ReportsTableResult";
  private static readonly UPDATE_REPORTS_BY_PARAMS: string =
    "UpdateReportsTable";
  private static readonly LEARNER_REPORTS_TB_LIST_LEN: string =
    "learnersreporttablelistlength";
  private static readonly LEARNER_ACT_REPORTS_TB_LIST_LEN: string =
    "learneractivityreporttablelistlength";
  private static readonly APP_NUMBER_DISTANCE_TRAVEL_REPORTS_TB_LIST_LEN: string =
    "appnumberdistancetravelreporttablelistlength";
  private static readonly COMM_ENGLISH_DISTANCE_TRAVEL_REPORTS_TB_LIST_LEN: string =
    "commenglishdistancetravelreporttablelistlength";
  private static readonly COMM_WELSH_DISTANCE_TRAVEL_REPORTS_TB_LIST_LEN: string =
    "commwelshdistancetravelreporttablelistlength";
  private static readonly DIG_LIT_DISTANCE_TRAVEL_REPORTS_TB_LIST_LEN: string =
    "diglitdistancetravelreporttablelistlength";
  private static readonly DIG_LIT_SELF_ASSESS_DISTANCE_TRAVEL_REPORTS_TB_LIST_LEN: string =
    "diglitselfassessdistancetravelreporttablelistlength";
  private static readonly OVERALL_INITIAL_ASSESSMENT_RESULT_REPORT_TB_LIST_LEN: string =
    "overallinitialassessmentresultreporttablelistlength";
  private static readonly APP_NUMBER_INITIAL_ASSESSMENT_BREAKDOWN_REPORTS_TB_LIST_LEN: string =
    "appnumberinitialassessmentbreakdownreporttablelistlength";
  private static readonly COMM_ENGLISH_INITIAL_ASSESSMENT_BREAKDOWN_REPORTS_TB_LIST_LEN: string =
    "commenglishinitialassessmentbreakdownreporttablelistlength";
  private static readonly COMM_WELSH_INITIAL_ASSESSMENT_BREAKDOWN_REPORTS_TB_LIST_LEN: string =
    "commwelshinitialassessmentbreakdownreporttablelistlength";
  private static readonly DIG_LIT_INITIAL_ASSESSMENT_BREAKDOWN_REPORTS_TB_LIST_LEN: string =
    "diglitinitialassessmentbreakdownreporttablelistlength";
  private static readonly APP_NUMBER_DISTANCE_TRAVEL_REPORTS_SKILL_TB_LIST_LEN: string = "appnumberdistancetravelbyskillreporttablelistlength";
  private static readonly COMM_ENGLISH_DISTANCE_TRAVEL_REPORTS_SKILL_TB_LIST_LEN: string = "commenglishdistancetravelbyskillreporttablelistlength";
  private static readonly COMM_WELSH_DISTANCE_TRAVEL_REPORTS_SKILL_TB_LIST_LEN: string = "commwelshdistancetravelbyskillreporttablelistlength";
  private static readonly DIG_LIT_DISTANCE_TRAVEL_REPORTS_SKILL_TB_LIST_LEN: string = "diglitdistancetravelbyskillreporttablelistlength";
  private static readonly DIG_LIT_SELF_ASSESS_DISTANCE_TRAVEL_REPORTS_SKILL_TB_LIST_LEN: string = "diglitselfassessdistancetravelbyskillreporttablelistlength";
  private static readonly SCREENER_OVERALL_RESULT_REPORTS_SKILL_TB_LIST_LEN: string = "overallscreenerresultreporttablelistlength";
  private static readonly LEARNER_GET_REPORT_CHART: string = "GetReportChart";
  private static readonly RESET_LEARNERS_TABLE_REPORT: string =
    "resetlearnersreporttablelist";
  private static readonly RESET_LEARNERS_ACTIVITY_TABLE_REPORT: string =
    "resetlearneractivityreporttablelist";
  private static readonly RESET_APP_NUMBER_DISTANCE_TRAVEL_REPORT: string =
    "resetappnumberdistancetravelreporttablelist";
  private static readonly RESET_COMM_ENGLISH_DISTANCE_TRAVEL_REPORT: string =
    "resetcommenglishdistancetravelreporttablelist";
  private static readonly RESET_COMM_WELSH_DISTANCE_TRAVEL_REPORT: string =
    "resetcommwelshdistancetravelreporttablelist";
  private static readonly RESET_DIG_LIT_DISTANCE_TRAVEL_REPORT: string =
    "resetdiglitdistancetravelreporttablelist";
  private static readonly RESET_DIG_LIT_SELF_ASSESS_DISTANCE_TRAVEL_REPORT: string =
    "resetdiglitselfassessdistancetravelreporttablelist";
  private static readonly RESET_OVERALL_INITIAL_ASSESSMENT_RESULT_REPORT: string =
    "resetoverallinitialassessmentresultreporttablelist";
  private static readonly RESET_APP_NUMBER_INITIAL_ASSESSMENT_BREAKDOWN_REPORT: string =
    "resetappnumberinitialassessmentbreakdownreporttablelist";
  private static readonly RESET_COMM_ENGLISH_INITIAL_ASSESSMENT_BREAKDOWN_REPORT: string =
    "resetcommenglishinitialassessmentbreakdownreporttablelist";
  private static readonly RESET_COMM_WELSH_INITIAL_ASSESSMENT_BREAKDOWN_REPORT: string =
    "resetcommwelshinitialassessmentbreakdownreporttablelist";
  private static readonly RESET_DIG_LIT_INITIAL_ASSESSMENT_BREAKDOWN_REPORT: string =
    "resetdiglitinitialassessmentbreakdownreporttablelist";
  private static readonly RESET_APP_NUMBER_DISTANCE_TRAVEL_SKILL_REPORT: string = "resetappnumberdistancetravelbyskillreporttablelist";
  private static readonly RESET_COMM_ENGLISH_DISTANCE_TRAVEL_SKILL_REPORT: string = "resetcommenglishdistancetravelbyskillreporttablelist";
  private static readonly RESET_COMM_WELSH_DISTANCE_TRAVEL_SKILL_REPORT: string = "resetcommwelshdistancetravelbyskillreporttablelist";
  private static readonly RESET_DIG_LIT_DISTANCE_TRAVEL_SKILL_REPORT: string = "resetdiglitdistancetravelbyskillreporttablelist";
  private static readonly RESET_DIG_LIT_SELF_ASSESS_DISTANCE_TRAVEL_SKILL_REPORT: string = "resetdiglitselfassessdistancetravelbyskillreporttablelist";
  private static readonly RESET_OVERALL_SCREENER_RESULT_REPORT = 'resetoverallscreenerresultreporttablelist'; 
  private static readonly EXPORT_REPORTS_TABLE: string = "ExportReportsTable";
  constructor(
    private http: HttpClient,
    @Inject(APP_CONFIG) private config: IAppConfig
  ) {}

  public getReportNames$(tabIndex: number): Observable<string[]> {
    let params = new HttpParams().set(AppConstants.TAB_INDEX, tabIndex);

    return this.http.get<string[]>(
      this.baseUrl +
        LearnerReportService.path +
        LearnerReportService.GET_REPORT_NAMES,
        { params }
    );
  }

  public getGetReportDetails$(
    reportType: number
  ): Observable<ReportDetailsDto> {
    let params = new HttpParams().set(AppConstants.ID, String(+reportType));

    return this.http.get<ReportDetailsDto>(
      this.baseUrl +
        LearnerReportService.path +
        LearnerReportService.GET_REPORT_DETAILS,
      { params }
    );
  }

  public updateReportsFilter$(
    reportType: number,
    filter: UpdateReportsFilter
  ): Observable<boolean> {
    const params = new HttpParams().append(
      AppConstants.ID,
      String(+reportType)
    );
    const headers = new HttpHeaders({
      [HttpHeadersConstants.CONTENT_TYPE]: HttpHeadersConstants.APP_JSON,
    });

    return this.http.post<boolean>(
      this.baseUrl +
        LearnerReportService.path +
        LearnerReportService.UPDATE_REPORTS_BY_FILTER,
      filter,
      { params, headers }
    );
  }

  public getReportsFilter$(
    reportType: number
  ): Observable<UpdateReportsFilter> {
    let params = new HttpParams().set(AppConstants.ID, String(+reportType));

    return this.http.get<UpdateReportsFilter>(
      this.baseUrl +
        LearnerReportService.path +
        LearnerReportService.GET_REPORTS_FILTER,
      { params }
    );
  }

  public generateReports$(reportType: number): Observable<boolean> {
    const params = new HttpParams().append(
      AppConstants.ID,
      String(+reportType)
    );

    return this.http.get<boolean>(
      this.baseUrl +
        LearnerReportService.path +
        LearnerReportService.GENERATE_REPORTS,
      { params }
    );
  }

  public getReportsTableResult$(
    reportType: number,
    pageNumber: number,
    isInitialLoad: boolean
  ): Observable<LearnersReportDto[]> {
    let params = new HttpParams();
    params = params.append(AppConstants.ID, String(+reportType));
    params = params.append(AppConstants.PAGE_NUMBER, String(+pageNumber + 1));
    params = params.append(AppConstants.IS_INITIAL_LOAD, String(isInitialLoad));

    return this.http.get<LearnersReportDto[]>(
      this.baseUrl +
        LearnerReportService.path +
        LearnerReportService.REPORTS_TABLE_RESULT,
      { params }
    );
  }

  public updateReportsTable$(
    reportType: number,
    tableParam: ReportsTableParams
  ): Observable<boolean> {
    const params = new HttpParams().append(
      AppConstants.ID,
      String(+reportType)
    );
    const headers = new HttpHeaders({
      [HttpHeadersConstants.CONTENT_TYPE]: HttpHeadersConstants.APP_JSON,
    });

    return this.http.post<boolean>(
      this.baseUrl +
        LearnerReportService.path +
        LearnerReportService.UPDATE_REPORTS_BY_PARAMS,
      tableParam,
      { params, headers }
    );
  }

  public getReportsTableListLength$(reportType: number): Observable<number> {
    let subDirectory: string;

    switch (reportType) {
      case ReportTypes.Learners:
        subDirectory = LearnerReportService.LEARNER_REPORTS_TB_LIST_LEN;
        break;
      case ReportTypes.LearnersActivity:
        subDirectory = LearnerReportService.LEARNER_ACT_REPORTS_TB_LIST_LEN;
        break;
      case ReportTypes.AppNumberDistanceTravel:
        subDirectory =
          LearnerReportService.APP_NUMBER_DISTANCE_TRAVEL_REPORTS_TB_LIST_LEN;
        break;
      case ReportTypes.CommEnglishDistanceTravel:
        subDirectory =
          LearnerReportService.COMM_ENGLISH_DISTANCE_TRAVEL_REPORTS_TB_LIST_LEN;
        break;
      case ReportTypes.CommWelshDistanceTravel:
        subDirectory =
          LearnerReportService.COMM_WELSH_DISTANCE_TRAVEL_REPORTS_TB_LIST_LEN;
        break;
      case ReportTypes.DigLitDistanceTravel:
        subDirectory =
          LearnerReportService.DIG_LIT_DISTANCE_TRAVEL_REPORTS_TB_LIST_LEN;
        break;
      case ReportTypes.DigLitSelfAssessDistanceTravel:
        subDirectory =
          LearnerReportService.DIG_LIT_SELF_ASSESS_DISTANCE_TRAVEL_REPORTS_TB_LIST_LEN;
        break;
      case ReportTypes.OverallInitialAssessmentResult:
        subDirectory =
          LearnerReportService.OVERALL_INITIAL_ASSESSMENT_RESULT_REPORT_TB_LIST_LEN;
        break;
      case ReportTypes.AppNumberInitialAssessmentBreakdown:
        subDirectory =
          LearnerReportService.APP_NUMBER_INITIAL_ASSESSMENT_BREAKDOWN_REPORTS_TB_LIST_LEN;
        break;
      case ReportTypes.CommEnglishInitialAssessmentBreakdown:
        subDirectory =
          LearnerReportService.COMM_ENGLISH_INITIAL_ASSESSMENT_BREAKDOWN_REPORTS_TB_LIST_LEN;
        break;
      case ReportTypes.CommWelshInitialAssessmentBreakdown:
        subDirectory =
          LearnerReportService.COMM_WELSH_INITIAL_ASSESSMENT_BREAKDOWN_REPORTS_TB_LIST_LEN;
        break;
      case ReportTypes.DigLitInitialAssessmentBreakdown:
        subDirectory =
          LearnerReportService.DIG_LIT_INITIAL_ASSESSMENT_BREAKDOWN_REPORTS_TB_LIST_LEN;
        break;
      case ReportTypes.AppNumberDistanceTravelBySkill:
        subDirectory = LearnerReportService.APP_NUMBER_DISTANCE_TRAVEL_REPORTS_SKILL_TB_LIST_LEN;
        break;
      case ReportTypes.CommEnglishDistanceTravelBySkill:
        subDirectory = LearnerReportService.COMM_ENGLISH_DISTANCE_TRAVEL_REPORTS_SKILL_TB_LIST_LEN;
        break;
      case ReportTypes.CommWelshDistanceTravelBySkill:
        subDirectory = LearnerReportService.COMM_WELSH_DISTANCE_TRAVEL_REPORTS_SKILL_TB_LIST_LEN;
        break;
      case ReportTypes.DigLitDistanceTravelBySkill:
        subDirectory = LearnerReportService.DIG_LIT_DISTANCE_TRAVEL_REPORTS_SKILL_TB_LIST_LEN;
        break;
      case ReportTypes.DigLitSelfAssessDistanceTravelBySkill:
        subDirectory = LearnerReportService.DIG_LIT_SELF_ASSESS_DISTANCE_TRAVEL_REPORTS_SKILL_TB_LIST_LEN;
        break;
      case ReportTypes.OverallScreenerResult:
        subDirectory = LearnerReportService.SCREENER_OVERALL_RESULT_REPORTS_SKILL_TB_LIST_LEN;   
      default:
        break;
    }

    return this.http.get<number>(
      this.baseUrl + LearnerReportService.path + subDirectory
    );
  }

  public getLearnerReportsChart$(
    reportType: number
  ): Observable<ReportsChart[]> {
    let subDirectory: string = LearnerReportService.LEARNER_GET_REPORT_CHART;
    const params = new HttpParams().append(
      AppConstants.ID,
      String(+reportType)
    );

    return this.http.get<ReportsChart[]>(
      this.baseUrl + LearnerReportService.path + subDirectory,
      { params }
    );
  }

  public resetLearnerReportTable$(reportType: number): Observable<boolean> {
    let subDirectory: string;

    switch (reportType) {
      case ReportTypes.Learners:
        subDirectory = LearnerReportService.RESET_LEARNERS_TABLE_REPORT;
        break;
      case ReportTypes.LearnersActivity:
        subDirectory =
          LearnerReportService.RESET_LEARNERS_ACTIVITY_TABLE_REPORT;
        break;
      case ReportTypes.AppNumberDistanceTravel:
        subDirectory =
          LearnerReportService.RESET_APP_NUMBER_DISTANCE_TRAVEL_REPORT;
        break;
      case ReportTypes.CommEnglishDistanceTravel:
        subDirectory =
          LearnerReportService.RESET_COMM_ENGLISH_DISTANCE_TRAVEL_REPORT;
        break;
      case ReportTypes.CommWelshDistanceTravel:
        subDirectory =
          LearnerReportService.RESET_COMM_WELSH_DISTANCE_TRAVEL_REPORT;
        break;
      case ReportTypes.DigLitDistanceTravel:
        subDirectory =
          LearnerReportService.RESET_DIG_LIT_DISTANCE_TRAVEL_REPORT;
        break;
      case ReportTypes.DigLitSelfAssessDistanceTravel:
        subDirectory =
          LearnerReportService.RESET_DIG_LIT_SELF_ASSESS_DISTANCE_TRAVEL_REPORT;
        break;
      case ReportTypes.OverallInitialAssessmentResult:
        subDirectory =
          LearnerReportService.RESET_OVERALL_INITIAL_ASSESSMENT_RESULT_REPORT;
        break;
      case ReportTypes.AppNumberInitialAssessmentBreakdown:
        subDirectory =
          LearnerReportService.RESET_APP_NUMBER_INITIAL_ASSESSMENT_BREAKDOWN_REPORT;
        break;
      case ReportTypes.CommEnglishInitialAssessmentBreakdown:
        subDirectory =
          LearnerReportService.RESET_COMM_ENGLISH_INITIAL_ASSESSMENT_BREAKDOWN_REPORT;
        break;
      case ReportTypes.CommWelshInitialAssessmentBreakdown:
        subDirectory =
          LearnerReportService.RESET_COMM_WELSH_INITIAL_ASSESSMENT_BREAKDOWN_REPORT;
        break;
      case ReportTypes.DigLitInitialAssessmentBreakdown:
        subDirectory =
          LearnerReportService.RESET_DIG_LIT_INITIAL_ASSESSMENT_BREAKDOWN_REPORT;
        break;
      case ReportTypes.AppNumberDistanceTravelBySkill:
        subDirectory = LearnerReportService.RESET_APP_NUMBER_DISTANCE_TRAVEL_SKILL_REPORT;
        break;
      case ReportTypes.CommEnglishDistanceTravelBySkill:
        subDirectory = LearnerReportService.RESET_COMM_ENGLISH_DISTANCE_TRAVEL_SKILL_REPORT;
        break;                                          
      case ReportTypes.CommWelshDistanceTravelBySkill:
        subDirectory = LearnerReportService.RESET_COMM_WELSH_DISTANCE_TRAVEL_SKILL_REPORT;
        break;
      case ReportTypes.DigLitDistanceTravelBySkill:
        subDirectory = LearnerReportService.RESET_DIG_LIT_DISTANCE_TRAVEL_SKILL_REPORT;
        break;
      case ReportTypes.DigLitSelfAssessDistanceTravelBySkill:
        subDirectory = LearnerReportService.RESET_DIG_LIT_SELF_ASSESS_DISTANCE_TRAVEL_SKILL_REPORT;
        break;
      case ReportTypes.OverallScreenerResult:
        subDirectory = LearnerReportService.RESET_OVERALL_SCREENER_RESULT_REPORT;
        break;                  
      case ReportTypes.LearnerStatisticsAllCourses:
      case ReportTypes.LearnerStatisticsSingleCourse: 
      case ReportTypes.ScreenerStatisticsAllCourses: 
      case ReportTypes.ScreenerStatisticsSingleCourse:
      case ReportTypes.InitialAssessmentStatisticsAllCourses:
      case ReportTypes.InitialAssessmentStatisticsSingleCourse:
        subDirectory = AggregateReportTypeList.find(r => r.id == reportType).resetTable;
      default:
        break;
    }

    return this.http.get<boolean>(
      this.baseUrl + LearnerReportService.path + subDirectory
    );
  }

  public exportReportsTable$(
    reportType: number
  ): Observable<LearnersReportDto[]> {
    let params = new HttpParams();
    params = params.append(AppConstants.ID, String(+reportType));

    return this.http.get<LearnersReportDto[]>(
      this.baseUrl +
        LearnerReportService.path +
        LearnerReportService.EXPORT_REPORTS_TABLE,
      { params }
    );
  }
}
